// src/components/ServiceIcon.js
import React from "react";
import {
  TbBuilding,
  TbTruck,
  TbLeaf,
  TbRoad,
  TbCrane,
  TbRecycle,
  TbBulldozer
} from "react-icons/tb";

export default function ServiceIcon({ name, className = "icon" }) {
  const MAP = {
    excavator: TbBulldozer,     // Hafriyat
    truck: TbTruck,             // Nakliyat
    building: TbBuilding,       // İnşaat
    demolition: TbCrane,        // Yıkım
    rental: TbBulldozer,        // Kiralık İş Makineleri
    leaf: TbLeaf,               // Çevre Düzenleme
    road: TbRoad                // Yol Yapım İnşaatı
  };

  const Icon = MAP[name] || TbBuilding;
  return <Icon className={className} aria-hidden="true" />;
}

export function MetaIcon({ type = "info" }) {
  const META = {
    truck: TbTruck,
    year: TbBuilding,
    leaf: TbLeaf,
    crane: TbCrane,
    recycle: TbRecycle
  };
  const MIcon = META[type] || TbBuilding;
  return <MIcon className="meta-icon" aria-hidden="true" />;
}